import * as React from 'react';
import styled from '@emotion/styled';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import { G300 } from '@atlaskit/theme/colors';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';

const StyledMatchBillDateSuccessFlag = styled.div({
  margin: '100px auto 0 auto',
  width: '400px',
});

const MatchBillDateSuccessFlag = ({
  onSuccessDateChange,
  setOnSuccessDateChange,
}: {
  onSuccessDateChange: {
    title?: string;
    description: string;
  } | null;
  setOnSuccessDateChange: (
    value: {
      title?: string;
      description: string;
    } | null
  ) => void;
}) => {
  const description = <p>It will be set when you confirm the order.</p>;

  return (
    <StyledMatchBillDateSuccessFlag>
      <FlagGroup onDismissed={() => setOnSuccessDateChange(null)}>
        {onSuccessDateChange && (
          <AutoDismissFlag
            title="New bill date added"
            description={description}
            appearance="normal"
            id="not-found-error"
            icon={<SuccessIcon label="Success" primaryColor={G300} />}
          />
        )}
      </FlagGroup>
    </StyledMatchBillDateSuccessFlag>
  );
};

export default MatchBillDateSuccessFlag;
